(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/other-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/other-device.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.bankid.OtherDevice = Marionette.View.extend({
    template: function template(data) {
      return svs.player_login.templates.ssn_login(data);
    },
    behaviors: function behaviors() {
      var behaviors = [{
        behaviorClass: svs.player_login.behaviors.AboutBankid
      }, {
        behaviorClass: svs.player_login.behaviors.BankIDErrorHandling
      }, {
        behaviorClass: svs.player_login.behaviors.TabHandler
      }];

      if (!this.options.model.get('hideUsernameLogin')) {
        behaviors.push({
          behaviorClass: svs.player_login.behaviors.UsernameLogin
        });
      }

      return behaviors;
    },
    ui: {
      ssnInput: '.js-ssn-input',
      loginButton: '.js-bankid-login',
      backButton: '.js-back-to-bankid',
      rememberMe: '.js-remember-me',
      loginTab: '#loginTab',
      qrCodeLogin: '.js-bankid-qr-login'
    },
    events: {
      'click @ui.loginButton': 'onLoginClick',
      'click @ui.backButton': 'onBackButtonClick',
      'paste @ui.ssnInput': 'onSsnPaste',
      'keyup @ui.ssnInput': 'onSsnKeyup',
      'click @ui.ssnInput': 'onSsnClick',
      'click @ui.loginTab': 'onLoginTabClick',
      'click @ui.qrCodeLogin': 'onQrCodeLogin'
    },
    modelEvents: {
      'change:ssn': 'render'
    },
    dashRegexp: /([0-9]{8})(?!-)/,
    prependTwentyRegexp: /^0/,
    prependNineteenRegexp: /^[3-9]{1,1}|^(?!19|20)[0-9]{2,2}|^190|^(?!200)[2-9][0-9]{2,2}/,
    onAttach: function onAttach() {
      this.ui.ssnInput.focus();
    },
    onSsnPaste: function onSsnPaste(e) {
      var ssn;

      if (e.originalEvent.clipboardData) {
        ssn = e.originalEvent.clipboardData.getData('text');
      } else {
        ssn = window.clipboardData.getData('text');
      }

      e.preventDefault();
      ssn = ssn && ssn.trim();

      if (/[0-9-]/g.test(ssn) && ssn.length < 14) {
        this.ui.ssnInput.val(this.prependDigits(ssn));
      }
    },
    onSsnKeyup: function onSsnKeyup(event) {
      var keyCode = event.charCode || event.keyCode;
      var ssn;
      var value = this.ui.ssnInput.val(); 

      if (keyCode !== 8 && keyCode !== 46) {
        if (value.length === 12) {
          ssn = value.replace(/-/g, '');

          if (!isNaN(parseInt(ssn, 10)) && value.indexOf('-') > -1) {
            this.ui.ssnInput.val(value + this.checkSumCalc(ssn));
          }
        } else if (value.length < 4 || value.length === 8) {
          this.ui.ssnInput.val(this.prependDigits(value));
        }
      }
    },
    onSsnClick: function onSsnClick() {
      var value = this.ui.ssnInput.val(),
          newValue = this.prependDigits(value);

      if (value.length !== newValue.length) {
        this.ui.ssnInput.val(newValue);
        this.ui.ssnInput.prop('selectionStart', newValue.length).prop('selectionEnd', newValue.length);
      }
    },
    onBackButtonClick: function onBackButtonClick() {
      svs.player_login.router.navigate('/', true);
    },
    onLoginClick: function onLoginClick(e) {
      var _this = this;

      var personalNumber = this.ui.ssnInput.val(),
          personalNumberParam = personalNumber.replace(/-/g, '');
      Boolean(e) && e.preventDefault();
      this.model.set('sameDevice', false);

      if (this.ui.rememberMe.prop('checked')) {
        svs.components.Storage.browser.set('ssn', 'customer_login', personalNumber, svs.components.Storage.constants.EXPIRES_1YEAR);
      } else {
        svs.components.Storage.browser.remove('ssn', 'customer_login');
      }

      if (svs.components.formValidation.validateRequiredFields(['ssn']) && svs.components.formValidation.validateFields(['ssn'])) {
        this.model.set({
          ssn: personalNumber
        }, {
          silent: true
        });
        svs.player_login.radio.request('autoStartToken', true, personalNumberParam).done(function (autostartToken) {
          _this.model.set('autoStartToken', autostartToken);

          svs.player_login.router.navigate("poll?ast=".concat(autostartToken), true);
        }).fail(function (err) {
          _this.triggerMethod('bankIDError', err);
        });
      }
    },
    onQrCodeLogin: function onQrCodeLogin(e) {
      var _this2 = this;

      var logger = svs.core.log.getLogger('module:player-login');
      e.preventDefault(); 

      svs.core.deviceSession.set('bankIdLoginMethod', 'customer_login', 'qr', function (err) {
        if (err) {
          logger.debug('Error when saving bankid login method to device session.');
        }

        _this2.model.set('sameDevice', false);

        _this2.model.set('isSsnLogin', false);

        _this2.model.set('isSsnFallback', false);

        _this2.model.set('startBankId', false);

        svs.player_login.router.navigate("/bankid?".concat(_this2.model.toQueryString('bankid')), true);
      });
    },

    prependDigits: function prependDigits(number) {
      if (number) {
        number = number.trim();

        if (number.match(this.prependTwentyRegexp)) {
          number = "20".concat(number);
        } else if (number.match(this.prependNineteenRegexp)) {
          number = "19".concat(number);
        }

        if (number.length >= 8) {
          number = number.replace(this.dashRegexp, '$1-');
        }
      }

      return number;
    },

    checkSumCalc: function checkSumCalc(number) {
      var sum = 0;
      var delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
      var i;
      number = number.substring(2);

      for (i = 0; i < number.length; i++) {
        sum += parseInt(number.charAt(i), 10);
      }

      for (i = number.length - 1; i >= 0; i -= 2) {
        sum += delta[parseInt(number.charAt(i), 10)];
      }

      if (10 - sum % 10 === 10) {
        return 0;
      }

      return 10 - sum % 10;
    }
  });
})(Backbone, _, svs);
 })(window);